module.exports = __webpack_public_path__ + "home.svg?8f4b04136fb3b190e976cb6f88b2d605";